import {from} from 'rxjs'
import {groupBy, mergeMap, map, reduce} from 'rxjs/operators'

export const reduceModelFromKeys = (defaultFunc) => (list) => (acc, elem) => {
  let key = elem["conditionId"];
  let obj = list[key];
  let x = obj ? { [key] : obj} : { [key] : { conditionId: elem.conditionId, categoryId: elem.categoryId, ...defaultFunc(elem), others: null } }
  return {...acc, ...x};
};

export const reduceArrayToObject = (key) => (acc, elem) => {
  acc[elem[key]] = elem;
  return acc;
};

export const reduceArrayToObjectById = reduceArrayToObject('id');

export const flattenInnerArray = (key) => (acc, elem) => {
  return acc.concat(elem[key]);
}

export const flattenConditions = flattenInnerArray('conditions');

const flattenTableRow = mergeMap((row) => {
  if (row.crosssegments) {
    return from(Object.values(row.crosssegments)).pipe(
      map((value) => ({row: row.name, col: value.name, value: value}))
    )
  }else {
    throw "No crosssegments"
  }
});

const reduceGroupStreamToArray = mergeMap((group$) => group$.pipe(
  reduce((acc, value) => ({name:acc.name,
      acc: acc.acc + value.count,
      total: acc.total + value.total,
      crosssegments:{...acc.crosssegments, [value.name]:{...value}} }),
    {name:group$.key, acc:0, total:0, crosssegments:{}})
))

export const transposeTable = (table) => {
  let result = null;
  from(table).pipe(
    flattenTableRow,
    groupBy((e) => e.col, (e) => ({name: e.row, count: e.value.count, total: e.value.total})),
    reduceGroupStreamToArray,
    reduce((acc,val)=> ({...acc, [val.name]: val}), {})
  ).subscribe((d)=> {result = d;},()=>{ result = table });
  return result;
}